import * as React from 'react';

function ManageCustomer(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 24 24' {...props}>
      <g id='Group_71' data-name='Group 71' transform='translate(-582 228)'>
        <rect
          id='Rectangle_16'
          data-name='Rectangle 16'
          width={24}
          height={24}
          transform='translate(582 -228)'
          fill='#fff'
        />
        <g id='Group_68' data-name='Group 68' transform='translate(581 -229)'>
          <path
            id='Path_6'
            data-name='Path 6'
            d='M3,9.223A4.223,4.223,0,0,1,7.223,5H17.781A4.223,4.223,0,0,1,22,9.223v8.446a4.223,4.223,0,0,1-4.223,4.223H7.223A4.223,4.223,0,0,1,3,17.669ZM7.223,7.112A2.112,2.112,0,0,0,5.112,9.223v8.446a2.112,2.112,0,0,0,2.112,2.112H17.781a2.112,2.112,0,0,0,2.112-2.112V9.223a2.112,2.112,0,0,0-2.112-2.112Z'
            transform='translate(0 0.112)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
            fillRule='evenodd'
          />
          <path
            id='Path_7'
            data-name='Path 7'
            d='M8.056,3A1.056,1.056,0,0,1,9.112,4.056V6.167A1.056,1.056,0,0,1,7,6.167V4.056A1.056,1.056,0,0,1,8.056,3Z'
            transform='translate(0.223 0)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
            fillRule='evenodd'
          />
          <path
            id='Path_8'
            data-name='Path 8'
            d='M16.056,3a1.056,1.056,0,0,1,1.056,1.056V6.167a1.056,1.056,0,0,1-2.112,0V4.056A1.056,1.056,0,0,1,16.056,3Z'
            transform='translate(0.669 0)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
            fillRule='evenodd'
          />
          <path
            id='Path_9'
            data-name='Path 9'
            d='M9.112,10.056A1.056,1.056,0,1,1,8.056,9,1.056,1.056,0,0,1,9.112,10.056Z'
            transform='translate(0.223 0.335)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
          />
          <path
            id='Path_10'
            data-name='Path 10'
            d='M13.112,10.056A1.056,1.056,0,1,1,12.056,9,1.056,1.056,0,0,1,13.112,10.056Z'
            transform='translate(0.446 0.335)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
          />
          <path
            id='Path_11'
            data-name='Path 11'
            d='M17.112,10.056A1.056,1.056,0,1,1,16.056,9,1.056,1.056,0,0,1,17.112,10.056Z'
            transform='translate(0.669 0.335)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
          />
          <path
            id='Path_12'
            data-name='Path 12'
            d='M9.112,14.056A1.056,1.056,0,1,1,8.056,13,1.056,1.056,0,0,1,9.112,14.056Z'
            transform='translate(0.223 0.558)'
            fill='#003ec4'
            stroke='#fff'
            strokeWidth={0.5}
          />
        </g>
      </g>
    </svg>
  );
}
export default ManageCustomer;
